import React from 'react'
import { Box, Button, Field, Message, Modal, Textarea } from '@workwhile/ui'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useAddQuestionModalContextValue } from '../context/AddQuestionModalProvider'
import { addQuestionSchema, AddQuestionSchema } from '../schema'

const DEFAULT_VALUES: AddQuestionSchema = {
  question: '',
  idealAnswer: '',
  evaluationCriteria: '',
}

export const AddQuestionModalMain = () => {
  const {
    state: {
      isOpen,
      mutationState: { isPending, isError, errorMessage },
    },
    actions: { close, submit, reset: resetMutation },
  } = useAddQuestionModalContextValue()

  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm<AddQuestionSchema>({
    resolver: zodResolver(addQuestionSchema),
    defaultValues: DEFAULT_VALUES,
  })

  const handleClose = () => {
    reset(DEFAULT_VALUES)
    resetMutation()
    close()
  }

  const onSubmit = handleSubmit((data) => {
    submit(data, {
      onSuccess: () => {
        handleClose()
      },
    })
  })

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      position="top"
      title="Add Question to Requirement"
      loading={isPending}
      showCancel
      customCta={
        <Button variant="primary" loading={isPending} onClick={onSubmit}>
          Add
        </Button>
      }
    >
      <Box
        as="form"
        onSubmit={(event) => {
          event.preventDefault()
          onSubmit()
        }}
      >
        <Field label="Question" error={errors.question?.message?.toString()}>
          <Textarea
            {...register('question')}
            aria-label="Question"
            minRows={3}
          />
        </Field>

        <Field
          label="Ideal Answer"
          error={errors.idealAnswer?.message?.toString()}
        >
          <Textarea
            {...register('idealAnswer')}
            aria-label="Ideal Answer"
            minRows={3}
          />
        </Field>

        <Field
          label="Evaluation Criteria"
          error={errors.evaluationCriteria?.message?.toString()}
        >
          <Textarea
            {...register('evaluationCriteria')}
            aria-label="Evaluation Criteria"
            minRows={3}
          />
        </Field>

        {isError && errorMessage ? (
          <Message variant="error" mt={3} borderRadius="small">
            {errorMessage}
          </Message>
        ) : null}
      </Box>
    </Modal>
  )
}
